import api from '../instance'

export function getCollaboratorsByCostCenterCode(costCenterCode) {
  return api.get(`/collaborators?costCenterCode=${costCenterCode}`)
}

export function registerCollaborator(collaborator) {
  return api.post(`/collaborators`, collaborator)
}
